@if (items.length) {
  <div class="h1-slider" role="region" aria-roledescription="carousel" aria-label="Student testimonials">
    <div
      #viewport
      class="h1-slider__viewport"
      [class.h1-slider__viewport--dragging]="isDragging()"
      (pointerdown)="swipe.onPointerDown($event)"
      (pointermove)="swipe.onPointerMove($event)"
      (pointerup)="swipe.onPointerUp($event)"
      (pointercancel)="swipe.onPointerCancel($event)"
    >
      <div
        class="h1-slider__track"
        [class.h1-slider__track--dragging]="isDragging()"
        [style.transform]="trackTransform()"
      >
        @for (slide of testimonialSlides(); track $index; let slideIndex = $index) {
          <div class="h1-slider__slide" [attr.aria-hidden]="testimonialSlide() !== slideIndex">
            <div [class]="slideGridClass(slide.length)">
              @for (t of slide; track t.studentName + t.review; let cardIndex = $index) {
                <article class="h1-testimonial">
                  <div class="h1-testimonial__stars" [attr.aria-label]="t.rating + ' out of 5 stars'">
                    @for (star of [1, 2, 3, 4, 5]; track star) {
                      <span aria-hidden="true" [class.is-dim]="star > t.rating">★</span>
                    }
                  </div>
                  <div class="h1-testimonial__body">
                    <p class="h1-testimonial__quote">"{{ t.review }}"</p>
                    @if (needsReadMore(t.review)) {
                      <button
                        type="button"
                        class="h1-testimonial__read-more"
                        (click)="openDetail(t)"
                      >
                        Read More →
                      </button>
                    }
                  </div>
                  <div class="h1-testimonial__person">
                    <div class="h1-testimonial__avatar" [class.has-image]="hasAvatar(t)" [ngStyle]="avatarStyle(t)">
                      @if (!hasAvatar(t)) {
                        <span aria-hidden="true">{{ initials(t.studentName) }}</span>
                      }
                    </div>
                    <div>
                      <div class="h1-testimonial__name">{{ t.studentName }}</div>
                      @if (subtitle(t)) {
                        <div class="h1-testimonial__course">{{ subtitle(t) }}</div>
                      }
                    </div>
                  </div>
                </article>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <div class="h1-slider__controls">
      <button
        type="button"
        class="h1-slider__arrow"
        (click)="prevTestimonialSlide()"
        [disabled]="testimonialSlide() === 0"
        aria-label="Previous testimonials"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false">
          <path d="m15 18-6-6 6-6"></path>
        </svg>
      </button>

      <div class="h1-slider__dots" role="tablist" aria-label="Select testimonial slide">
        @for (slide of testimonialSlides(); track $index) {
          <button
            type="button"
            role="tab"
            class="h1-slider__dot"
            [class.is-active]="testimonialSlide() === $index"
            [attr.aria-selected]="testimonialSlide() === $index"
            [attr.aria-label]="'Show slide ' + ($index + 1)"
            (click)="setTestimonialSlide($index)"
          ></button>
        }
      </div>

      <button
        type="button"
        class="h1-slider__arrow"
        (click)="nextTestimonialSlide()"
        [disabled]="testimonialSlide() === testimonialSlides().length - 1"
        aria-label="Next testimonials"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false">
          <path d="m9 18 6-6-6-6"></path>
        </svg>
      </button>
    </div>
  </div>

  @if (selectedDetail(); as detail) {
    <app-marketing-story-detail-modal [detail]="detail" (closed)="closeDetail()" />
  }
}
